var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50065 0.833496C3.83398 0.833496 0.833984 3.8335 0.833984 7.50016C0.833984 11.1668 3.83398 14.1668 7.50065 14.1668C11.1673 14.1668 14.1673 11.1668 14.1673 7.50016C14.1673 3.8335 11.1673 0.833496 7.50065 0.833496ZM6.16732 10.8335L2.83398 7.50016L3.77398 6.56016L6.16732 8.94683L11.2273 3.88683L12.1673 4.8335L6.16732 10.8335Z",
    fill: "#4ED4CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/CheckMark.5b1545c081feca954062c60a305b0534.svg";
export { ForwardRef as ReactComponent };